import React from "react";
import { useRouteMatch } from "react-router-dom";

import useHub from "data/hub/useHub";

import { useFeatures } from "components/FeatureFlag";

import ClientCard from "scenes/Hubly/components/HubModals/components/ClientCard/ClientCard";
import { useClientCardMode } from "scenes/Hubly/components/HubModals/components/ClientCard/hooks";

import { useWorkDesk } from "../hooks";

function WorkDeskPreloader() {
  const ffWorkDesk = useFeatures("work-desk-beta");
  const hub = useHub();
  const hubId = hub?.hubId;

  const {
    isWorkdeskClientPath,
    parentPathToIframePath,
    iframePathToWorkdeskParentPath,
  } = useWorkDesk();
  const { showNewClientCard } = useClientCardMode();

  const match = useRouteMatch({
    path: "/hub/:hubId/clients/:clientId",
    exact: false,
  });
  const hasClientId = Boolean(match?.params?.clientId);

  if (!ffWorkDesk) return null;
  if (!hubId) return null;

  const shouldShow = isWorkdeskClientPath || (showNewClientCard && hasClientId);
  const syncEnabled = showNewClientCard || isWorkdeskClientPath;

  return (
    <div
      style={{
        position: "absolute",
        top: "47px",
        left: "0px",
        width: "100vw",
        height: "calc(100vh - 57px)",
        backgroundColor: "white",
        zIndex: 109,
        overflow: "hidden",
        visibility: shouldShow ? "visible" : "hidden",
        pointerEvents: shouldShow ? "auto" : "none",
      }}
    >
      <ClientCard
        mapPathnameForIframeSrc={parentPathToIframePath}
        mapPathnameFromChild={iframePathToWorkdeskParentPath}
        initialPathnameOverride={`/hub/${hubId}`}
        syncEnabled={syncEnabled}
      />
    </div>
  );
}

export default WorkDeskPreloader;
